import React, { Component } from "react";
import { withTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, PageHeader, ListGroup, ListGroupItem, Modal } from "react-bootstrap";
import { invokeGetProgramWorkoutDates,
         invokeSetProgramDayBeginTime,
         invokeSetUnsubscribeAthleteFromMktplcProgram
       } from "../../utils/AwsInvoke";
import ModalPreWorkoutSurvey        from "../../components/modal/ModalPreWorkoutSurvey";
import ModalLoadingInfo             from "../../components/modal/ModalLoadingInfo";
import LoaderButton                 from "../../components/LoaderButton";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
import { Colors }                   from "../../utils/Colors";

import { Steps, Hints } from "intro.js-react"; // js code for welcome tour
import "intro.js/introjs.css"; // css for welcome tour
import "../../css/program/ProgramBegin.css";

var   white_label   = WhiteLabel();
const MainColor     = white_label.company_primary_btn_color;
const CloseBtnColor = white_label.company_close_btn_color;
var   ImgCoverURL   = white_label.aws_athlete_assets_url;
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

export default class ProgramBegin extends Component {
    constructor(props) {
        super(props);

        var image;
        var globalUserCompanyId = localStorage.getItem('globalUserCompanyId');

        this.state = {
            program_id:        `${this.props.match.params.id}`,
            mktplc_program_id: `${this.props.match.params.mktplc_program_id}`,
            title:             `${this.props.match.params.title}`,
            isLoading:         true,
            company_id:        globalUserCompanyId,
            name:              "",
            current_day:       1,
            current_week:      1,
            list:              [],
            days_completed:    [],
            weeks_completed:   [],
            survey_submitted_txt:      "",
            showModalPreWorkoutSurvey: false,
            showModalLoadingInfo:      false,
            showDeleteConfirmWin:      false,
            pageOverlay:               "inline",

            // Product Tour //
            stepsEnabled: false,
            initialStep: 0,
            steps: [
                {
                    element: ".startProgramTour",
                    intro: "Click the button and begin your workout program!",
                    position: 'left'
                },
                /*{
                    element: ".deleteProgramTour",
                    intro: "Delete the current program. Be careful though, you will no longer have access to this program or data once it's deleted.",
                    position: 'auto'
                },*/
                {
                    element: ".currentDayTour",
                    intro: "Your workout days for the week can be viewed here. Preview future workout days by clicking on the day.",
                    position: 'auto'
                },
                {
                    element: ".currentWeekTour",
                    intro: "Your workout weeks for the month can be viewed here. Preview future workout weeks by clicking on the week.",
                    position: 'auto'
                }
            ],
        };
    }

    async componentDidMount() {

        if (!this.props.isAuthenticated)
            return;

        try {
            this.renderSubProgramList();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    async renderSubProgramList() {
        this.setState({ pageOverlay: "inline"})

        var program_id        = this.state.program_id;
        var mktplc_program_id = this.state.mktplc_program_id; //
        var results           = await invokeGetProgramWorkoutDates(program_id);
        var data              = results.data;
        var days              = data["days"];
        var weeks             = data["weeks"];
        var program_completed = data["program_completed"];

        if(results.status) {
            var weekAndDay_obj = this.getCurrentWeekAndDay ("init", weeks, days);

            var title = this.state.title;

            this.setState({
                name:  title,
                weeks: weeks,
                days:  days,
                program_completed: program_completed,
                current_day:     weekAndDay_obj.current_day,
                current_week:    weekAndDay_obj.current_week,
                days_completed:  weekAndDay_obj.days_completed_arr,
                weeks_completed: weekAndDay_obj.weeks_completed_arr,
                pageOverlay: "none"
            })
        } else
            this.setState({
                pageOverlay: "none"
            })
    }

    getCurrentWeekAndDay = (new_week, weeks, days) => {
            var max_wk  = 0;
            var current_week_id;
            var days_completed_arr = [];
            var weeks_completed_arr= [];
            var weekAndDay_obj = {};

            var current_week;
            //console.log("1. getCurrentWeekAndDay() ------------------------");
            var track_compl_days_in_week = []; // week id plus current day

            //// 1. GET WEEKS ////
            for(var key in weeks) {
                var temp_week_id =  weeks[key].uid;
                var temp_week    =  weeks[key].week;
                var temp_week_compl = weeks[key].completed_week;

                track_compl_days_in_week.push([temp_week_id, 0])

                if(temp_week === new_week) current_week_id = temp_week_id;

                if(temp_week >= max_wk && temp_week_compl != null) {
                    current_week = temp_week + 1;
                    weeks_completed_arr.push(temp_week_id)
                    current_week_id = temp_week_id;
                }
            }
            // Temp solution; rewrite when theres more time
            // On first instance of this function, when component first loads,
            // assign the most recent week
            if(new_week === "init")
                new_week = current_week;

            //// 2. GET WEEKS ////
            var current_day;
            var prev_week;

            for(var key in days) {
                var max_day = 0;
                var temp_day       = days[key].day;
                var temp_day_id    = days[key].uid;
                var temp_week_id   = days[key].week_id;
                var temp_day_compl = days[key].completed_day;

                //// HOLD ALL COMPLETED DAYS IN ARRAY OF ALL THE WEEKS ////
                for(var l=0; l < track_compl_days_in_week.length; l++) {
                    if(track_compl_days_in_week[l][0] === temp_week_id && temp_day_compl != null) {
                        track_compl_days_in_week[l][1] = track_compl_days_in_week[l][1]+1; // assign current day to its week_id
                    }
                }

                //// GET ALL COMPLETED DAYS ////
                if(temp_day_compl != null)
                    days_completed_arr.push(temp_day_id)

                //// GET COMPLETED DAYS FOR CURRENT WEEK ////
                if(current_week_id === temp_week_id) { // go to 1st week;
                    if(temp_day >= max_day && temp_day_compl != null)
                        current_day = temp_day + 1;
                }
            }

            //// ON FIRST LOAD OF PROGRAM, WE NEED TO SET THE BELOW VARS
            if(new_week === undefined) {
                new_week     = 1;
                current_week = 1;
            }
            //console.log("days_completed_arr: " + days_completed_arr);
            //console.log("weeks_completed_arr: " + weeks_completed_arr);

            var week_num = new_week-1;


            var current_day;
            if(track_compl_days_in_week[week_num] != undefined)
                current_day = track_compl_days_in_week[week_num][1]+1;// subtract 1 since it's a 0 element array
            else {
                current_day = 1;
                current_week = 1;
            }

            weekAndDay_obj.current_day         = current_day;
            weekAndDay_obj.current_week        = current_week;
            weekAndDay_obj.days_completed_arr  = days_completed_arr;
            weekAndDay_obj.weeks_completed_arr = weeks_completed_arr;

            return weekAndDay_obj;
    }

    handleNewDayChange = (day_id, day_number) => {
        var current_day = parseInt(day_number);
        this.setState ({
            current_day: current_day
        });
    }

    handleNewWeekChange = (week_id, week_number) => {
        var current_week = parseInt(week_number);
        var days    = this.state.days;
        var weeks   = this.state.weeks;

        var weekAndDay_obj = this.getCurrentWeekAndDay (current_week, weeks, days);

        this.setState ({
            current_week: current_week,
            //current_day: 1 // every new week should reset the day back to 1
            current_day: weekAndDay_obj.current_day,
            days_completed: weekAndDay_obj.days_completed_arr,
            weeks_completed: weekAndDay_obj.weeks_completed_arr
        });
    }

    getDayContainer = (current_week_id, days, current_day) => {
        //console.log("---------- getDayContainer() -------------");
        var color_0, color_1, color_2, color_3, color_4, color_5, color_6;
            color_0 = "#000";
            color_1 = color_2 = color_3 = color_4 = color_5 = color_6 = "#808080";
        var day_slot_1, day_slot_2, day_slot_3, day_slot_4, day_slot_5, day_slot_6;
        var day_id_slot_1, day_id_slot_2, day_id_slot_3, day_id_slot_4, day_id_slot_5, day_id_slot_6;
        var t2_ctr = 0;

        var days_completed_arr = this.state.days_completed;
        //var day_ctr = 1; // day ctr needs to be used since the actual day # is not correct...fix!!!

        var days_lgth = days_completed_arr.length;

        for(var key in days) {
            var temp_week_id =  days[key].week_id;
            var temp_day     =  days[key].day;//day_ctr;//
            var temp_day_id  =  days[key].uid;
            var day_completed= -1;

            if(days_lgth > 0)
                day_completed = days_completed_arr.indexOf(temp_day_id);

            //// Match currently selected week ////
            //// rewrite below code when there's more time!!! ////

            if(current_week_id === temp_week_id) {
                //// Change Main DAY Color ////
                if(current_day === temp_day) if(day_completed != -1) color_0 = MainColor;

                if(current_day > temp_day) {
                    if(temp_day+2 < current_day) {
                        day_slot_1    = "0"+(temp_day);
                        day_id_slot_1 = temp_day_id;
                        if(day_completed != -1) color_1 = MainColor;
                    } else if(temp_day+1 < current_day) {
                        day_slot_2 = "0"+(temp_day);
                        day_id_slot_2 = temp_day_id;
                        if(day_completed != -1) color_2 = MainColor;
                    } else if(temp_day < current_day) {
                        day_slot_3 = "0"+temp_day;
                        day_id_slot_3 = temp_day_id;
                        if(day_completed != -1) color_3 = MainColor;
                    }
                }

                if(current_day < temp_day) {
                    if(t2_ctr === 0) {
                        day_slot_4 = "0"+temp_day;
                        day_id_slot_4 = temp_day_id;
                        if(day_completed != -1) color_4 = "#a2e01c";
                    } else if(t2_ctr === 1) {
                        day_slot_5 = "0"+temp_day;
                        day_id_slot_5 = temp_day_id;
                        if(day_completed != -1) color_5 = "#a2e01c";
                    } else if(t2_ctr === 2) {
                        day_slot_6 = "0"+temp_day;
                        day_id_slot_6 = temp_day_id;
                        if(day_completed != -1) color_6 = "#a2e01c";
                    }
                    t2_ctr++;
                }
            }
            //day_ctr++;
        }

        if(current_day != undefined) {
            var char_count = current_day.toString().length;
            if(char_count === 1) current_day = "0" + current_day;
        }

        return <span className="programBeginBox2">
                    <div className="currentDayTour programDayContainerTour">
                            <span className="programBeginWkTitle">DAY</span>
                            <span className="programBeginWkNumber" style={{color: color_0}}>{current_day}</span>
                            <span className="programBeginUnderlineNumberDay" style={{borderBottom: "4px solid " + MainColor}}/>
                            <span className="programWkRow">
                                <span className="programWkNumberLeftSide" style={{color: color_1}} onClick={() => this.handleNewDayChange(day_id_slot_1, day_slot_1)}>{day_slot_1} { /*}<span style={{position:"relative",left:"100px", top:"20px"}}><img src={require('../images/utils/checkmark_green.png')} width="16"/></span>*/ } </span>
                                <span className="programWkNumberLeftSide" style={{color: color_2}} onClick={() => this.handleNewDayChange(day_id_slot_2, day_slot_2)}>{day_slot_2}</span>
                                <span className="programWkNumberLeftSide" style={{color: color_3}} onClick={() => this.handleNewDayChange(day_id_slot_3, day_slot_3)}>{day_slot_3}</span>
                                <span className="programWkNumberRightSide" style={{color: color_4}} onClick={() => this.handleNewDayChange(day_id_slot_4, day_slot_4)}>{day_slot_4}</span>
                                <span className="programWkNumberRightSide" style={{color: color_5}} onClick={() => this.handleNewDayChange(day_id_slot_5, day_slot_5)}>{day_slot_5}</span>
                                <span className="programWkNumberRightSide" style={{color: color_6}} onClick={() => this.handleNewDayChange(day_id_slot_6, day_slot_6)}>{day_slot_6}</span>
                            </span>
                     </div>
                </span>
    }

    getWeekContainer = (current_week_id, weeks, current_week) => {

            var color_0, color_1, color_2, color_3, color_4, color_5, color_6;
                color_0 = "#000";
                color_1 = color_2 = color_3 = color_4 = color_5 = color_6 = "#808080";
            var wk_slot_1, wk_slot_2, wk_slot_3, wk_slot_4, wk_slot_5, wk_slot_6;
            var wk_id_slot_1, wk_id_slot_2, wk_id_slot_3, wk_id_slot_4, wk_id_slot_5, wk_id_slot_6;
            //var t1_ctr = 0;
            var t2_ctr = 0;

            var weeks_completed_arr = this.state.weeks_completed;

            var weeks_lgth = 0;
            if(weeks_completed_arr != undefined) weeks_lgth = weeks_completed_arr.length;

            for(var key in weeks) {
                var temp_week_id =  weeks[key].uid;
                var temp_week    =  weeks[key].week;
                var wk_completed= -1;

                if(weeks_lgth > 0)
                    wk_completed = weeks_completed_arr.indexOf(temp_week_id);

                //// Change Main DAY Color ////
                if(current_week === temp_week) if(wk_completed != -1) color_0 = MainColor;

                if(current_week > temp_week) {
                    if(temp_week+2 < current_week) {
                        wk_slot_1 = "0"+temp_week;
                        wk_id_slot_1 = temp_week_id;
                        if(wk_completed != -1) color_1 = MainColor;
                    } else if(temp_week+1 < current_week) {
                        wk_slot_2 = "0"+temp_week;
                        wk_id_slot_2 = temp_week_id;
                        if(wk_completed != -1) color_2 = MainColor;
                    } else if(temp_week < current_week) {
                        wk_slot_3 = "0"+temp_week;
                        wk_id_slot_3 = temp_week_id;
                        if(wk_completed != -1) color_3 = MainColor;
                    }
                }

                if(current_week < temp_week) {
                    if(t2_ctr === 0) {
                        wk_slot_4 = "0"+temp_week;
                        wk_id_slot_4 = temp_week_id;
                        if(wk_completed != -1) color_4 = MainColor;
                    } else if(t2_ctr === 1) {
                        wk_slot_5 = "0"+temp_week;
                        wk_id_slot_5 = temp_week_id;
                        if(wk_completed != -1) color_5 = MainColor;
                    } else if(t2_ctr === 2) {
                        wk_slot_6 = "0"+temp_week;
                        wk_id_slot_6 = temp_week_id;
                        if(wk_completed != -1) color_6 = MainColor;
                    }
                    t2_ctr++;
                }
            }
            // For some reason, current_week > 0 needs to be in this line otherwise the
            // current week does not progress from week 1 into week 2+
            if(current_week != undefined && current_week > 0) {
                var char_count = current_week.toString().length;
                if(char_count === 1) current_week = "0" + current_week;
            }

            return    <span className="programBeginBox">
                            <div className="currentWeekTour programWeekContainerTour">
                                <span className="programBeginWkTitle">WK</span>
                                <span className="programBeginWkNumber currentWeekTour" style={{color: color_0}}>{current_week}</span>
                                <span className="programBeginUnderlineNumber" style={{borderBottom: "4px solid " + MainColor}}/>
                                <span className="programWkRow">
                                    <span className="programWkNumberLeftSide" style={{color: color_1}} onClick={() => this.handleNewWeekChange(wk_id_slot_1, wk_slot_1)}>{wk_slot_1}</span>
                                    <span className="programWkNumberLeftSide" style={{color: color_2}} onClick={() => this.handleNewWeekChange(wk_id_slot_2, wk_slot_2)}>{wk_slot_2}</span>
                                    <span className="programWkNumberLeftSide" style={{color: color_3}} onClick={() => this.handleNewWeekChange(wk_id_slot_3, wk_slot_3)}>{wk_slot_3}</span>
                                    <span className="programWkNumberRightSide" style={{color: color_4}} onClick={() => this.handleNewWeekChange(wk_id_slot_4, wk_slot_4)}>{wk_slot_4}</span>
                                    <span className="programWkNumberRightSide" style={{color: color_5}} onClick={() => this.handleNewWeekChange(wk_id_slot_5, wk_slot_5)}>{wk_slot_5}</span>
                                    <span className="programWkNumberRightSide" style={{color: color_6}} onClick={() => this.handleNewWeekChange(wk_id_slot_6, wk_slot_6)}>{wk_slot_6}</span>
                                </span>
                            </div>
                        </span>
    }

    compare(a,b) {
      if (a.week_id < b.week_id)
        return -1;
      if (a.week_id > b.week_id)
        return 1;
      return 0;
    }


    renderProgramsList() {
            var total_time       = 1;//list[0].total_time;
            var difficulty_level = 1;//list[0].difficulty_level;
            var char_count = difficulty_level.toString().length;
            if(char_count === 1) difficulty_level = difficulty_level + ".0";

            var weeks = this.state.weeks;
            var days  = this.state.days;
            var name  = this.state.name;
            var title = this.state.title;

            var current_day  = this.state.current_day;
            var current_week = this.state.current_week;
            var current_week_id;
            var day_id;
            var week_ctr = 0;
            var day_ctr  = 0;

            for(var key in weeks) {
                var temp_week_id =  weeks[key].uid;
                var temp_week    =  weeks[key].week;
                if(current_week === temp_week) current_week_id = temp_week_id;

                week_ctr++;
            }

            // below is temp solution if days are not in order
            //if(days != undefined)
            //    days.sort(this.compare);

            // Temp solution of for-in loop; it's used solely to track the last day of the week - if
            // all other days are completed, we don't want the last day to increment by 1
            var day_ctr_per_week = 0; // track number of days in current week

            for(var key in days) {
                var temp_week_id   = days[key].week_id;
                if(temp_week_id === current_week_id) day_ctr_per_week++;
            }

            // Ensure that if all days are completed in a week, that the "Current Day"
            // is not higher than the actual number of days in the current week
            if(current_day > day_ctr_per_week) current_day = day_ctr_per_week;

            for(var key in days) {
                var temp_day       = days[key].day;
                var temp_day_id    = days[key].uid;
                var temp_week_id   = days[key].week_id;
                var temp_day_compl = days[key].completed_day;

                if(temp_day === current_day && temp_week_id === current_week_id)
                    day_id = temp_day_id;

                day_ctr++;
            }

            var week_container = this.getWeekContainer(current_week_id, weeks, current_week);
            var day_container  = this.getDayContainer(current_week_id, days, current_day);
            var program_id     = this.state.program_id;
            var image2;

            var cover_image = localStorage.getItem('coverImage');

            if(cover_image != undefined)
                image2 = <img src={ cover_image } width="100%"/> //require(`../../images/program_categories/`+image)

            var program_completed  = this.state.program_completed;
            var workout_btn        = "START TODAY'S WORKOUT";
            var program_finished_label;
            var confirm_label = this.state.survey_submitted_txt;

            if(program_completed) {
                workout_btn = "REVIEW PROGRAM";
                program_finished_label = <div>
                                            <br/>
                                        <span className="fontColorRed">PROGRAM FINISHED!</span>
                                         </div>

            }
            var mktplc_program_id = this.state.mktplc_program_id;
            var delete_button = "";

            ////////////////////////////////////////////////////////////////////////////
            ////   ONly Show Delete Button if it's an Athlete Marketplace Program   ////
            if(mktplc_program_id != 0)
                delete_button = <span className="programBeginExerciseTitle"
                                        //href={`/programDayWorkout/${program_id}/${day_id}/${title}`}
                                        onClick={this.handleDeleteProgram}>
                                        <LoaderButton
                                            //disabled = {}
                                            className="deleteProgramTour"
                                            bsSize   = "large"
                                            width    = "285px"
                                            height   = "40px"
                                            fontSize = "20px"
                                            btncolor = "gray"
                                            type     = "submit"
                                            isLoading= {this.state.isLoading}
                                            text     = "DELETE PROGRAM"
                                            loadingText="Deleting program…"
                                          />
                                 </span>
            ////
            var pre_workout_survey  = <div className="surveyPreWorkoutContainer"
                                             onClick={(e) => this.handlePreWorkoutSurvey(program_id, day_id)}>
                                            <span className="surveyPreWorkoutIcon" alt="Post-Workout Survey">
                                                    <FontAwesomeIcon icon="clipboard-list" className="iconPostWorkoutSurvey" style={{color: MainColor}}/>
                                                    <span className="surveyPreWorkoutIconText">survey*</span>
                                            </span>
                                      </div>
            if(this.state.company_id == posture_health_company_id)
                pre_workout_survey   = "";

            var programs = <span className="programBeginContaine">
                                    <span className="programBeginImage">
                                         { image2 }
                                    </span>
                                    <span className="programBeginFadeImage">
                                        <img src={require('../../images/utils/program_category_black_fade2.png')} height="60" width="100%"/>
                                    </span>
                                    <span className="programBeginTitle">{name}</span>

                                    { /************ WEEK ************/ }
                                    { week_container }

                                    { /************ DAYS ************/ }
                                    { day_container }
                                    <span  className="programBeginIntroBox">
                                            { /*}<span>
                                                <span className="glyphicon glyphicon-time beginGlyphIcon"/>
                                                Time: 55 mins
                                            </span>
                                            <span className="programBeginVertSpacer"/>
                                                <span className="glyphicon glyphicon-stats beginGlphIcon"/>
                                            &nbsp;&nbsp;Difficulty: Easy
                                            <span className="programBeginVertSpacer"/>
                                            { /*}<span className="glyphicon glyphicon-check beginGlphIcon"/>
                                            &nbsp;&nbsp;Completed: No*/ }
                                            <span className="programBeginVertSpacer"/>
                                            Total Weeks: <span className="fontColorBlack">{week_ctr}</span>
                                            <br/>
                                            Total Days: <span className="fontColorBlack">{day_ctr}</span>
                                            <br/>
                                            { program_finished_label }
                                    </span>
                                    <span  className="programBeginExerciseSummary">
                                        <div style={{fontSize:20, color:Colors.ok_button_bg}}>{ confirm_label }</div>
                                        <br/>
                                        <span className="programBeginExerciseTitle"
                                                onClick={(e) => this.handleSubmitClick(e, title, current_week, current_day, program_id, day_id)}>
                                                <LoaderButton
                                                    className="startProgramTour"
                                                    //disabled = {}
                                                    bsSize   = "large"
                                                    width    = "300px"
                                                    height   = "40px"
                                                    fontSize = "20px"
                                                    btncolor = {MainColor}
                                                    type     = "submit"
                                                    isLoading= {this.state.isLoading}
                                                    text     = { workout_btn }
                                                    loadingText="Logging in…"
                                                  />
                                              <br/><br/>
                                              <div style={{fontSize:11, color: "#666"}}>* Fill out the survey before you start your workout</div>
                                              { /*}<span className="glyphicon glyphicon-dashboard beginGlyphIcon"/>START TODAY'S WORKOUT(*/ }
                                         </span>
                                         { pre_workout_survey }
                                         <br/><br/><br/>
                                        { delete_button }
                                    </span>
                            </span>

        return programs;
    }

    handleSubmitClick = async (event, title, current_week, current_day, program_id, day_id) => {

          /*this.setState({
                showModalLoadingInfo: true // show "Congrats Subscription" Modal
          });*/

          var mktplc_program_id = this.state.mktplc_program_id;

          ////  BEGIN PROGRAM DAY START TIME  ////
          var results = await invokeSetProgramDayBeginTime(program_id, day_id);

          if(results.status) {
              var href = `/programDayWorkout/${program_id}/${day_id}/${title}/${current_week}-${current_day}/${mktplc_program_id}`;
              this.props.history.push(href);
              /*this.setState({
                    pageOverlay: "none",
                    showModalLoadingInfo: false,
                    loading_text: "We're loading your workout data."
              })*/
          } else
              this.setState({ pageOverlay: "none" })
    }

    handlePreWorkoutSurvey = (program_id, day_id) => {
            this.setState({
                showModalPreWorkoutSurvey: true,
                program_id: program_id,
                day_id: day_id
            })
    }

    handleDeleteProgram = event => {
        event.preventDefault();

        this.setState({
            showDeleteConfirmWin: true
        });
    }

    async deleteProgram () {
            this.setState({
                pageOverlay: "inline",
                showModalLoadingInfo: true,
                loading_text: "We're deleting your program... <br/><br/>'The two most powerful warriors are<br/>patience and time.' - Leo Tolstoy'"
            })

            var mktplc_program_id = this.state.mktplc_program_id;
            var new_program_id    = this.state.program_id;

            ///  Delete Program  ///
            ///  var program_id = this.state.program_id;
            ///  var results = await invokeSetDeleteSingleProgram(program_id);

            ///  Remove the athlete/subscriber from the marketplace program  ///
            var results = await invokeSetUnsubscribeAthleteFromMktplcProgram(new_program_id);
            var data    = results.data;

            if(results.status) {
                this.props.history.push("/")
                this.setState({
                    pageOverlay: "none",
                    showModalLoadingInfo: false
                })
            } else
                this.setState({
                    pageOverlay: "none",
                    showModalLoadingInfo: false
                })

    }

    renderLander() {
        return (
          <div className="lander">
            <h1>TS</h1>
            <p></p>
          </div>
        );
    }

    renderList() {
        return (
          <div className="list">
              {!this.state.isLoading && this.renderProgramsList()}
          </div>
        );
    }

    handleCloseDeleteConfirmWin = (action) => {
        this.setState({
            showDeleteConfirmWin: false
        });

        if(action === "delete") this.deleteProgram();
    }

    onSurveyComplete = () => {
        this.setState({
            survey_submitted_txt: "Thx, the survey was submitted.",
            showModalPreWorkoutSurvey: false
        })
    }

    ////  Begin: Show Help Tour  ////
    onExit = () => {
        this.setState(() => ({ stepsEnabled: false }));
    };

    showHelpTour = () => {
        this.setState(() => ({ stepsEnabled: true }));
    }

    ////  End: Show Help Tour  ////

    render() {
        let closeModalPreWorkoutSurvey = () => this.setState({ showModalPreWorkoutSurvey: false }); //close simple modal window
        let closeModalLoadingInfo = () => this.setState({ showModalLoadingInfo: false }); //close simple modal window
        var loading_text = this.state.loading_text;

        const {
          stepsEnabled,
          steps,
          initialStep,
        } = this.state;

        return (
          <div className="HomeProgramBegin">
              <span className = "dashboardMainIconHelpTour glyphicon glyphicon-question-sign"
                    onClick   = {this.showHelpTour}/>
              {this.renderList()}

              <Steps
                enabled={stepsEnabled}
                steps={steps}
                initialStep={initialStep}
                onExit={this.onExit}
                options= {{disableInteraction:true}}
              />

              {this.state.showModalPreWorkoutSurvey ?
                <ModalPreWorkoutSurvey
                    show             = { this.state.showModalPreWorkoutSurvey}
                    onHide           = { closeModalPreWorkoutSurvey}
                    onSurveyComplete = { this.onSurveyComplete }
                    program_id       = { this.state.program_id }
                    day_id           = { this.state.day_id  }
                />
              : null}

            {this.state.showModalLoadingInfo ?
              <ModalLoadingInfo
                  modalWidth    = { 388 }
                  modalHeight   = { 150 }
                  show          = { this.state.showModalLoadingInfo }
                  message       = { loading_text }
                  //onHide = { closeModalLoadingInfo }
              />
            : null}
              { /*this.props.isAuthenticated ? this.renderNotes() : this.renderLander()*/ }
              <div>
                    <span className="pageOVerlay" style={{display:this.state.pageOverlay}}></span>
                    <Modal style={{position:"absolute", top: 150}}
                           show={this.state.showDeleteConfirmWin}
                           onHide={() => this.handleCloseDeleteConfirmWin("close")}
                           aria-labelledby="contained-modal-title"
                         >
                           <Modal.Header closeButton>
                             <Modal.Title id="contained-modal-title">
                                 <span className="marketplaceModalProgramTitle">
                                     <b>Confirm Program Deletion</b>
                                 </span>
                             </Modal.Title>
                           </Modal.Header>
                           <Modal.Body>
                               <div className="marketplaceModalProgramSummary">
                                   Are you sure you want to delete the  "{ this.state.name }" program?
                               </div>
                           </Modal.Body>
                           <Modal.Footer>
                                { /*}<Button onClick={() => this.handleCloseDeleteConfirmWin("close")}>Close</Button>
                            <Button bsstyle="danger" onClick={() => this.handleCloseDeleteConfirmWin("delete")}>Yes, DELETE</Button>*/ }
                                <LoaderButton
                                    bsSize   = "large"
                                    height   = "38px"
                                    width    = "100px"
                                    fontSize = "17px"
                                    type     = "submit"
                                    btncolor = { CloseBtnColor }
                                    text     = "Close"
                                    onClick  = {() => this.handleCloseDeleteConfirmWin("close")}
                                    loadingText = "Closing …"
                                  />
                                &nbsp; &nbsp;
                                <LoaderButton
                                    bssize   = "large"
                                    height   = "38px"
                                    width    = "140px"
                                    fontSize = "17px"
                                    type     = "submit"
                                    disabled = {this.state.submitBtnDisabled}
                                    btncolor = { Colors.delete_button_dark_red_bg }
                                    isLoading= {this.state.isLoading}
                                    text     = "Yes, DELETE"
                                    onClick  = {() => this.handleCloseDeleteConfirmWin("delete")}
                                    loadingText ="Deleting..."
                                  />
                           </Modal.Footer>
                     </Modal>
              </div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/ProgramBegin.js